module.exports = __webpack_public_path__ + "img/infographics_4.c4b5ec0f.png";